import React from "react";
import { useParams, Navigate } from "react-router-dom";
import ArticleTemplate from "@/components/templates/ArticleTemplate";
import { INSIGHTS_BY_SLUG, getRelatedArticles, asCard } from "@/data/insights";

const InsightsArticle = () => {
  const { slug } = useParams();
  const article = INSIGHTS_BY_SLUG[slug];

  // Unknown slug — send back to the index rather than showing a blank page.
  if (!article) return <Navigate to="/insights" replace />;

  const relatedArticles = getRelatedArticles(slug, 3).map(asCard);

  return <ArticleTemplate article={{ ...article, relatedArticles }} />;
};

export default InsightsArticle;
